import React from 'react';
import MultiSelectComponent from './MultiSelectComponent';

const MultiSelectCartoesPostagem = ({
  options,
  inputRef,
  errors,
  control,
  className,
  valor,
  aoMudar,
  ...rest
}) => {

  return (
    <>
        <MultiSelectComponent
          className={className}
          options={options}
          name="nuCartao"
          label="Cartão Postagem"
          inputRef={inputRef}
          errors={errors}
          id="nuCartao"
          valor={valor}
          aoMudar={aoMudar}
          control={control}
          {...rest}
        />
      
    </>
  );
};

export default MultiSelectCartoesPostagem;
